// src/features/marketResearch/components/sections/Footer.tsx
import React from 'react';
import { Typography, Box } from '@mui/material';

interface Props {
  reportId?: string | number;
  reportDate?: string;
  companyName?: string;
}

export const Footer: React.FC<Props> = ({ reportId, reportDate, companyName }) => (
  <Box
    component="footer"
    sx={{
      mt: 6, // Ensure enough space from the last SectionContainer
      py: 2.5,
      px: 2,
      borderTop: (theme) => `1px solid ${theme.palette.divider}`, // Uses lightTheme.palette.divider
      backgroundColor: 'background.default', // Uses lightTheme.palette.background.default
      color: 'text.secondary', // Uses lightTheme.palette.text.secondary
      '@media print': {
        // MuiCssBaseline handles main print text styling
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        py: 1.5,
        textAlign: 'center',
      },
    }}
  >
    <Typography
      variant="caption" // Uses lightTheme.typography.caption
      display="block"
      align="center"
    >
      {companyName ? `${companyName} ` : ''}
      {reportId ? `Report ID: ${reportId}` : ''}
      {reportDate && reportId ? ` | ` : ''}
      {reportDate ? `Date: ${reportDate}` : ''}
      {!reportId && !reportDate && !companyName && `© ${new Date().getFullYear()} All Rights Reserved.`}
    </Typography>
  </Box>
);
